import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
	Breadcrumb,
	BreadcrumbHome,
	BreadcrumbItem,
	Loading,
	Module,
	ModuleBody,
	SecondaryNavigation,
	SecondaryNavigationTitle,
	Wrapper,
} from '@wfp/ui';

import { useCurrentEvent, useEventId } from '../../hooks/event';
import { FullWarningEvent, Warning, WarningEventType } from '../../restapi/types';
import { isFirstEvent } from '../../restapi/warningEvent';
import { EventEdit } from './EventEdit';
import { lastHomepageUrl } from '../../utils/navigation';
import { type SimpleDate } from '../../utils/SimpleDate';


let dataForEewEvent: FullWarningEvent | undefined;

export function setDataForNewEvent(date?: SimpleDate, warning?: Warning) {
	if (date) {
		dataForEewEvent = new FullWarningEvent();
		dataForEewEvent.type = warning ? WarningEventType.updated : WarningEventType.raised;
		dataForEewEvent.date = date;
		const w = warning || new Warning();  // in case of raised event this is empty
		dataForEewEvent.warning = w;
		dataForEewEvent.likelihood = w.latestEvent.likelihood;
		dataForEewEvent.impact = w.latestEvent.impact;
		dataForEewEvent.seriousness = w.latestEvent.seriousness;
	} else {
		dataForEewEvent = undefined;
	}
}

export function PageEvent() {
	const eventId = useEventId();
	const loadedEvent = useCurrentEvent();
	const [newEvent] = useState(dataForEewEvent);
	const e = eventId ? loadedEvent : newEvent;

	const pageTitle = !e ? '...' :  // still loading
		!e.id ? (  // no event id, we are creating something
			isFirstEvent(e) ? 'Create warning' : 'Create update'
		) : (  // we are editing an already created event
			isFirstEvent(e) ? 'Edit warning' : 'Edit update'
		);

	return (<div key={eventId}>
		<SecondaryNavigation>
			<Breadcrumb>
				<BreadcrumbItem>
					<Link to="/"><BreadcrumbHome/></Link>
				</BreadcrumbItem>
				<BreadcrumbItem>
					<Link to={lastHomepageUrl}>Homepage</Link>
				</BreadcrumbItem>
				<BreadcrumbItem disableLink>{pageTitle}</BreadcrumbItem>
			</Breadcrumb>
			<SecondaryNavigationTitle>{pageTitle}</SecondaryNavigationTitle>
		</SecondaryNavigation>

		<Wrapper className="main-wrapper" background="lighter" pageWidth="lg" spacing="md">
			{!e ? (
				eventId ?
					<Loading withOverlay={false} active small/>
					: <Module><ModuleBody>To create a new warning please come back to the <a href="/">home page</a>,
						select an edition and click "New warning" button.</ModuleBody></Module>
			) : <EventEdit event={e}/>}
		</Wrapper>
	</div>);
}
